import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import infoSvg from '../../../assets/img/information.svg';

interface Props {
  text: string;
  className?: string;
}

export default function Clue({ text, className }: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex flex-col rounded-[8px] border-[1px] border-[#52C7FA] bg-[#E7F5FB] !px-3 !py-2 lg:flex-row lg:items-center lg:gap-[12px] lg:!px-[20px] lg:!py-[12px]',
        className,
      )}
    >
      <img src={infoSvg} alt="info" className="h-5 w-5" />

      <p className="!mb-0 text-sm font-medium lg:text-lg">{t(text)}</p>
    </div>
  );
}
